import { useState, useEffect, useRef } from 'react';

function useFileInput() {
  const [value, setValue] = useState(null);
  const [loaded, setLoaded] = useState(0);
  const fileRef = useRef(null);

  const convertFileToBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  useEffect(
    function () {
      if(!value) return;
      convertFileToBase64(value)
        .then((encodedFile) => setLoaded(encodedFile))
        .catch((err) => {
          console.log('error encoding file');
          console.log(err);
        });
    },
    [value]
  );

  const handleChange = (event) => {
    setValue(event.target.files[0]);
  };

  return {
    value,
    onChange: handleChange,
    loaded,
    fileRef,
  };
}

export default useFileInput;
